module.exports = __webpack_public_path__ + "assets/img/a2.8681bf5f.jpg";